// v-hotkey="'ctrl+s'": clicks the element when the key combination is pressed
// (replaces @undecaf/vue-hotkey, which only supports Vue 2).
const MODIFIERS = ["ctrl", "shift", "alt", "meta"];

function parseHotkey(value) {
  const parts = String(value || "")
    .toLowerCase()
    .split("+")
    .map((part) => part.trim());
  return {
    key: parts.find((part) => !MODIFIERS.includes(part)),
    modifiers: MODIFIERS.filter((modifier) => parts.includes(modifier)),
  };
}

function matches(event, hotkey) {
  return (
    !!hotkey.key &&
    event.key.toLowerCase() === hotkey.key &&
    MODIFIERS.every((modifier) => event[`${modifier}Key`] === hotkey.modifiers.includes(modifier))
  );
}

export default {
  mounted(el, binding) {
    el._hotkey = parseHotkey(binding.value);
    el._hotkeyHandler = (event) => {
      if (matches(event, el._hotkey)) {
        event.preventDefault();
        el.click();
      }
    };
    document.addEventListener("keydown", el._hotkeyHandler);
  },
  updated(el, binding) {
    el._hotkey = parseHotkey(binding.value);
  },
  unmounted(el) {
    document.removeEventListener("keydown", el._hotkeyHandler);
  },
};
